import React from "react";

const SparkScreen = () => {
  return (
    <div style={styles.container}>
      <h1>Coming soon SparkScreen</h1>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    fontSize: "24px",
  },
};

export default SparkScreen;
